// 募集ごとのページ（/careers/jobs/<id>）を Google の求人検索に載せるための、掲載の情報。
// 募集の中身（職種・業務内容・給与・働き方）は careersJobs.js が正本なので、ここには書かない。
import { WORKSTYLE } from './careersJobs';

// 募集ごとのページに出す、全職種共通の働き方（行の見出しは、採用サイトの「チームと働き方」と同じ）。
// 構造化データの説明文にも、同じ見出しと文言で入れる（lib/structuredData.js）
export const WORKSTYLE_HEADING = '勤務地と働き方';
export const WORKSTYLE_NOTE = '全職種で共通です。';
export const WORKSTYLE_ROWS = [
  ['勤務形態', WORKSTYLE.place],
  ['リモート', WORKSTYLE.remote],
  ['時間', WORKSTYLE.hours],
];

// 日本語の職種名（構造化データの title と、ページの見出し・タイトル）。2026-10-19 代表の指示で作った。
// 職種名が英語だけだと、日本語で探す人に当たりにくいため。中身は careersJobs.js の各募集の役割の説明から取り、
// 役割を足したり変えたりしていない。募集を足したら、ここにも足す（足さないとテストが落ちる）
export const JOB_TITLE_JA = {
  'ai-product-builder': 'AIエンジニア（プロダクト開発）',
  researcher: 'AIリサーチャー（研究開発）',
  fde: '顧客常駐型AIエンジニア（FDE）',
  'engineer-intern': 'エンジニアインターン（AI開発）',
  'domain-product-lead': 'AIプロダクトマネージャー',
  'ai-consultant': 'AIコンサルタント',
  'business-intern': '営業・コンサルティングのインターン',
};

// 掲載日（構造化データの datePosted。Google の求人検索では必須）: その募集を salt-2.com に最初に載せた日。
// いまの7職種は、採用サイトを新しくした 2026-10-18 に公開した（それまでのサイトの募集は別の職種だった）。
// 募集を足したら、ここにもその日を足す（足さないとテストが落ちる）。
// 募集を締め切ったら careersJobs.js から外す。ページ・サイトマップ・構造化データも一緒に消える。
export const DATE_POSTED = {
  'ai-product-builder': '2026-10-18',
  researcher: '2026-10-18',
  fde: '2026-10-18',
  'engineer-intern': '2026-10-18',
  'domain-product-lead': '2026-10-18',
  'ai-consultant': '2026-10-18',
  'business-intern': '2026-10-18',
};

// 「2026-10-18」→「2026年10月18日」（ページに出す掲載日）
export const formatPostedDate = (iso) => {
  const m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[1]}年${Number(m[2])}月${Number(m[3])}日` : '';
};
